import { create } from "zustand";

interface FocusState {
  focusedIssueId: string | null;
  lastFocusedIssueId: string | null;
  setFocusedIssue: (issueId: string | null) => void;
  setLastFocusedIssue: (issueId: string | null) => void;
  clearFocus: () => void;
  resetFocus: () => void;
}

export const useFocusStore = create<FocusState>((set) => ({
  focusedIssueId: null,
  lastFocusedIssueId: null,
  setFocusedIssue: (issueId: string | null) => {
    set({
      focusedIssueId: issueId,
      lastFocusedIssueId: issueId, // Always set lastFocusedIssueId to the new focus
    });
  },
  setLastFocusedIssue: (issueId: string | null) => {
    set({ lastFocusedIssueId: issueId });
  },
  clearFocus: () => {
    set({
      focusedIssueId: null,
    });
  },
  resetFocus: () => {
    set({
      focusedIssueId: null,
      lastFocusedIssueId: null,
    });
  },
}));
